import { render } from "./PlayCanvas.vue?vue&type=template&id=5f70e4b0"
import script from "./PlayCanvas.vue?vue&type=script&lang=js"
export * from "./PlayCanvas.vue?vue&type=script&lang=js"

import "./PlayCanvas.vue?vue&type=style&index=0&id=5f70e4b0&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__